var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-voicy-holder fill-height"},[(_vm.highlighted)?_c('WHighlighted',{attrs:{"card-options":_vm.cardOptions,"content":_vm.content}}):_c('WDefault',{attrs:{"card-options":_vm.cardOptions,"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }